// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";

import {timeConverter} from "timeConverter/timeConverter"

export default function SurveysTableData(surveys, onActionClick) {
  function handleActionClick(survey){
    onActionClick(survey)
  }


  function formatType(type){
    const lowercaseType =  type.toLowerCase().replace(/_/g, " ")
    return lowercaseType.charAt(0).toUpperCase() + lowercaseType.slice(1)
  }

  const Survey = ({ title, name, description, createdAt, updatedAt, createdBy }) => (
    <MDBox lineHeight={1} textAlign="left" >
      <MDTypography display="block" variant="caption" color="dark" fontWeight="bold">
        {formatType(name)}
      </MDTypography>
      <MDBox display="flex" pt={0.7} >
        <MDTypography display="flex" variant="caption" color="text" fontWeight="medium" pr={0.5}>
          {"Title:"}
        </MDTypography>
        <MDTypography display="flex" variant="caption" color="text" fontWeight="regular">
            {title}
        </MDTypography>
      </MDBox>
      <MDBox display="flex" pt={0.5} >
        <MDTypography display="flex" variant="caption" color="text" fontWeight="medium" pr={0.5}>
          {"Description:"}
        </MDTypography>
        <MDTypography display="flex" variant="caption" color="text" fontWeight="regular">
            {description}
        </MDTypography>
      </MDBox>
      <MDBox display="flex" pt={0.5} >
        <MDTypography display="flex" variant="caption" color="text" fontWeight="medium" pr={0.5}>
          {"Created at:"}
        </MDTypography>
        <MDTypography display="flex" variant="caption" color="text" fontWeight="regular">
            {timeConverter(createdAt)}
        </MDTypography>
      </MDBox>
      <MDBox display="flex" pt={0.5} >
        <MDTypography display="flex" variant="caption" color="text" fontWeight="medium" pr={0.5}>
          {"Updated at:"}
        </MDTypography>
        <MDTypography display="flex" variant="caption" color="text" fontWeight="regular">
            {timeConverter(updatedAt)}
        </MDTypography>
      </MDBox>
      <MDBox display="flex" pt={0.5} >
        <MDTypography display="flex" variant="caption" color="text" fontWeight="medium" pr={0.5}>
          {"Created by:"}
        </MDTypography>
        <MDTypography display="flex" variant="caption" color="text" fontWeight="regular">
            {createdBy}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  function getRows(surveys){
    if(surveys === null){
      return []
    }
    surveys = surveys['data']['surveys']
    if(surveys.length === 0){
      return []
    }
    return surveys.map((survey) => (
              {
                survey: 
                <>
                {(survey["survey_definition"]["survey_name"] === 'PERSONAL_DATA_SURVEY' || survey["survey_definition"]["survey_name"] === 'PRODUCT_DEFAULT_SURVEY') ?
                  <Survey 
                  title={survey["survey_definition"]["survey_title"]}
                  name={survey["survey_definition"]["survey_name"]}
                  description={survey["survey_definition"]["survey_short_description"]}
                  createdAt={survey["survey_definition"]["created_at"]}
                  updatedAt={survey["survey_definition"]["updated_at"]}
                  createdBy={"System"}
                  />
                :

                  <Survey 
                  title={survey["survey_definition"]["survey_title"]}
                  name={survey["survey_definition"]["survey_name"]}
                  description={survey["survey_definition"]["survey_short_description"]}
                  createdAt={survey["survey_definition"]["created_at"]}
                  updatedAt={survey["survey_definition"]["updated_at"]}
                  createdBy={"AbuStefan"}
                  />

                }
                </>,
                

                action: (
                  <MDBox alignItems="center" display="flex" sx={{position:"absolute", right:"5rem"}}>
                  {(survey["survey_definition"]["survey_name"] === 'PERSONAL_DATA_SURVEY' || survey["survey_definition"]["survey_name"] === 'PRODUCT_DEFAULT_SURVEY') &&
                    <MDBadge badgeContent="System survey" color="error" variant="gradient" size="md" />
                  }
                    <MDButton component="a" href="#" onClick={() => handleActionClick(survey)}>
                      <MDBadge badgeContent={"View survey"} color="dark" variant="gradient" size="lg" />
                    </MDButton>
                  </MDBox>
                )
              }
    ))

  }

  return {
    columns: [
      { Header: "survey", accessor: "survey", width: "45%", align: "left" },
      { Header: "action", accessor: "action", align: "center" },
    ],

    rows: getRows(surveys),
  }
}
